import { TileLayer, WMSTileLayer } from "react-leaflet";

import { useSelectedPersonalLayers } from "hooks/layerHooks";
import { isWMSLayer, useSelectedOverlayers } from "hooks/mapHooks";

export function RenderOverlayers() {
  const overlayers = useSelectedOverlayers();
  const selectedPersonalLayers = useSelectedPersonalLayers();

  return (
    <>
      {overlayers.map((overlayer, index) => {
        if (isWMSLayer(overlayer)) {
          return (
            <WMSTileLayer
              key={overlayer.id}
              {...overlayer.wms}
              zIndex={selectedPersonalLayers.length + index + 1}
            />
          );
        }
        return (
          <TileLayer
            key={overlayer.id}
            url={overlayer.url}
            zIndex={selectedPersonalLayers.length + index + 1}
          />
        );
      })}
    </>
  );
}
